
  import React from "react"
  import Component from "/Users/gareth.riddiford/Git/GitHub-OUP/ELT-online-practice-help-docs-v2/src/layouts/index.js"
  import data from "/Users/gareth.riddiford/Git/GitHub-OUP/ELT-online-practice-help-docs-v2/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js